'use client';

import { format, getDaysInMonth } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * The Home greeting band: a time-of-day greeting with the user's first name
 * and the cycle date line ("terça, 3 jul · dia 3 de 31"). The privacy (eye)
 * toggle lives in the app top bar (AppHeader), so it is not duplicated here.
 */
export function HomeGreeting({ name }: { name: string }) {
  const now = new Date();
  const hour = now.getHours();
  const greeting = hour < 12 ? 'Bom dia' : hour < 18 ? 'Boa tarde' : 'Boa noite';

  const weekday = format(now, 'EEEE', { locale: ptBR }).replace('-feira', '');
  const dayMonth = format(now, 'd MMM', { locale: ptBR });
  const dateLine = `${weekday}, ${dayMonth} · dia ${now.getDate()} de ${getDaysInMonth(now)}`;

  return (
    <header className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
      <h1 className="text-2xl font-semibold tracking-tight text-text-primary sm:text-3xl">
        {greeting}, <span className="text-accent-brand">{name}</span>.
      </h1>
      <p className="font-mono text-xs text-text-tertiary">{dateLine}</p>
    </header>
  );
}
